import React from "react";
import { Chart } from "react-google-charts";
import PropTypes from "prop-types";
import Config from "conFig.js";
const Vantaihanghoa = React.memo(function Vantaihanghoa(props) {
  const { thangnam } = props;
  const [socontainer, setSocontainer] = React.useState(0);
  const [sodaukeo, setSodaukeo] = React.useState(0);
  const [sotaxitai, setSotaxitai] = React.useState(0);
  const [soxetai, setSoxetai] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getvantaihanghoa = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/DashBoard/dashvantaihanghoa?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setSocontainer(data[0].socontainer);
        setSodaukeo(data[0].sodaukeo);
        setSotaxitai(data[0].sotaxitai);
        setSoxetai(data[0].soxetai);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const data = [
    ["Task", "Tỷ lệ"],
    ["Container (" + socontainer + " chiếc)", parseInt(socontainer)],
    ["Xe đầu kéo (" + sodaukeo + " chiếc)", parseInt(sodaukeo)],
    ["Xe taxi tải (" + sotaxitai + " chiếc)", parseInt(sotaxitai)],
    ["Xe tải (" + soxetai + " chiếc)", parseInt(soxetai)],
  ];
  React.useEffect(() => {
    getvantaihanghoa();
  }, [thangnam]);
  return (
    <Chart
      chartType="PieChart"
      loader={<div>Loading</div>}
      data={data}
      height="99%"
      options={{
        chartArea: {
          //marginTop: "-30px",
          width: "97%",
          height: "90%",
        },
        animation: {
          startup: true,
          easing: "linear",
          duration: 800,
        },
        backgroundColor: "transparent",
        hAxis: {
          textStyle: {
            color: "#ffffff",
          },
        },
        vAxis: {
          textStyle: {
            color: "#ffffff",
          },
        },
        legend: {
          textStyle: {
            color: "#ffffff",
          },
          position: "left",
        },
        titleTextStyle: {
          color: "#ffffff",
        },
      }}
    />
  );
});

Vantaihanghoa.propTypes = {
  thangnam: PropTypes.object,
};
export default Vantaihanghoa;
